export const MAX_HEIGHT_SIDEBAR = 600;
export const MOBILE_BREAKPOINT_WIDTH = 768;
